<template>
  <v-tooltip bottom z-index="600">
    <template #activator="{on}">
      <v-chip v-on="on" :color="color" :text-color="textColor"> <v-icon class="small mr-1 my-2">fa-plane-departure</v-icon>{{ text }}</v-chip>
    </template>
    <div>
      <h2>{{ $t("travelService.types.flight") }} ({{ $t("global.request") }})</h2>
      {{ $t("travelService.departureAirport") }}: {{ startPlaceText }}<br />
      {{ $t("travelService.arrivalAirport") }}: {{ endPlaceText }}<br />
      {{ $t("travelService.class") }}: {{ seatClassText }} <br />
      {{ $t("travelService.registeredBaggageWillBeAssigned") }}
      <v-icon small v-if="travelServiceOrderItem.flight.is_baggage === 1" color="success">fa-check</v-icon>
      <v-icon small v-else color="error">fa-times</v-icon> <br />
      {{ $t("travelService.startFlightDate") }}: {{ travelServiceOrderItem.flight.start_date }} {{ travelServiceOrderItem.flight.start_time }} <br />
      {{ $t("travelService.isReturnRoute") }}
      <v-icon small v-if="travelServiceOrderItem.flight.return_date !== null" color="success">fa-check</v-icon>
      <span v-else-if="travelServiceOrderItem.flight.additionalSegments.length > 0">
        <v-icon small color="success">fa-bezier-curve</v-icon>
        {{ $t("travelService.additionalSegments") }}
      </span>
      <v-icon small v-else color="error">fa-times</v-icon> <br />
      <template v-if="travelServiceOrderItem.flight.return_date !== null">
        {{ $t("travelService.returnFlightDate") }}: {{ travelServiceOrderItem.flight.return_date }} {{ travelServiceOrderItem.flight.return_time }}<br />
      </template>
      <travel-service-order-item-common-tooltip-part :travel-service-order-item="travelServiceOrderItem" />
    </div>
  </v-tooltip>
</template>

<script>
import { allFlightClassTypes } from "../../../staticData/TravelServiceTypes";
import TravelServiceOrderItemCommonTooltipPart from "./TravelServiceOrderItemCommonTooltipPart";

export default {
  name: "TravelServiceOrderItemFlightChip",
  components: { TravelServiceOrderItemCommonTooltipPart },
  props: {
    travelServiceOrderItem: { required: true, type: Object },
    color: { required: false, type: String, default: "" },
    textColor: { required: false, type: String, default: "" },
    text: { required: false, type: String, default: "Usługa lotnicza" }
  },
  data: () => ({
    startPlaceText: "",
    endPlaceText: ""
  }),
  watch: {
    "travelServiceOrderItem.flight.start_place_id"() {
      this.downloadStartPlace();
    },
    "travelServiceOrderItem.flight.end_place_id"() {
      this.downloadEndPlace();
    }
  },
  computed: {
    seatClassText() {
      if (typeof this.travelServiceOrderItem.flight.seat_class !== "undefined") {
        return allFlightClassTypes().find(v => v.value === this.travelServiceOrderItem.flight.seat_class).text;
      }
      return "";
    }
  },
  methods: {
    downloadStartPlace() {
      if (this.travelServiceOrderItem.flight.start_place_id !== null) {
        this.$store.dispatch("Location/getLocation", { placeId: this.travelServiceOrderItem.flight.start_place_id }).then(result => {
          this.startPlaceText = result.text;
        });
      }
    },
    downloadEndPlace() {
      if (this.travelServiceOrderItem.flight.end_place_id !== null) {
        this.$store.dispatch("Location/getLocation", { placeId: this.travelServiceOrderItem.flight.end_place_id }).then(result => {
          this.endPlaceText = result.text;
        });
      }
    }
  },
  created() {
    this.downloadStartPlace();
    this.downloadEndPlace();
  }
};
</script>

<style scoped></style>
